import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3123f40d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["alt"]
const _hoisted_3 = { class: "item-category" }

import { PropType, ref, watch } from "vue"
  import RoomItemProps from "@/types/RoomItemProps"
  import { Switch } from "@headlessui/vue"
  import categories from "@/types/Categories"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoomItem',
  props: {
    item: {
      type: Object as PropType<RoomItemProps>,
      default: undefined,
      required: false,
    },
    category: {
      type: Object as PropType<typeof categories[0]>,
      required: true,
    },
  },
  emits: ["open-category", "clear-category"],
  setup(__props, { emit }: { emit: ({
    (e: 'open-category', key: string): void
    (e: 'clear-category', key: string): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props

  

  

  const isSelected = ref(false)

  watch(isSelected, (value) => {
    if (value) {
      emit("open-category", props.category.key)
    } else {
      emit("clear-category", props.category.key)
    }
  })

  const getImage = (itemName: string) => {
    return "https://storage.googleapis.com/oliver-render-public/assets/" + itemName
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Switch), {
    class: "room-item",
    modelValue: isSelected.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSelected).value = $event)),
    as: "template"
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", null, [
        (__props.item)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: getImage(__props.item.image),
              alt: __props.item.image
            }, null, 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: "https://api.lorem.space/image/furniture?w=200&h=200",
              alt: `${__props.category.name} placeholder`,
              class: "placeholder-image"
            }, null, 8, _hoisted_2)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.category.name), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})